import React, { useState, useReducer } from "react";
import { ReactComponent as LeftAlign } from "../assets/img/left_align.svg";
import { ReactComponent as RightAlign } from "../assets/img/right_align.svg";
import { ReactComponent as TopAlign } from "../assets/img/top_align.svg";
import { ReactComponent as BottomAlign } from "../assets/img/bottom_align.svg";
import { ReactComponent as HorizontalAlign } from "../assets/img/horizontal_align.svg";
import { ReactComponent as VerticalAlign } from "../assets/img/vertical_align.svg";
import { ReactComponent as LeftStack } from "../assets/img/left_stack.svg";
import { ReactComponent as RightStack } from "../assets/img/right_stack.svg";
import { ReactComponent as TopStack } from "../assets/img/top_stack.svg";
import { ReactComponent as BottomStack } from "../assets/img/bottom_stack.svg";
import { alignItems } from "./service";
import "./RightSideModal.css";

const StackAndAlign = ({
  selectionManager,
  getObjectKey,
  items,
  historyManager,
  projectId,
  currentRoom,
  loadRoom,
  forceUpdate,
}) => {
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [notificationMessage, setNotificationMessage] = useState({});
  const [isRightPaneLoading, setIsRightPaneLoading] = useState(false);
  const alignImages = [
    {
      icon: LeftAlign,
      direction: "left",
      text: "Left",
      isApplicableForGroup: false,
    },
    {
      icon: RightAlign,
      direction: "right",
      text: "Right",
      isApplicableForGroup: false,
    },
    {
      icon: HorizontalAlign,
      direction: "h_center",
      text: "Center",
      isApplicableForGroup: false,
    },
    {
      icon: TopAlign,
      direction: "top",
      text: "Top",
      isApplicableForGroup: true,
    },
    {
      icon: BottomAlign,
      direction: "bottom",
      text: "Bottom",
      isApplicableForGroup: true,
    },
    {
      icon: VerticalAlign,
      direction: "v_center",
      text: "Middle",
      isApplicableForGroup: true,
    },
  ];

  const stackImages = [
    {
      icon: LeftStack,
      from: "left",
      text: "Left to Right",
    },
    {
      icon: RightStack,
      from: "right",
      text: "Right to Left",
    },
    {
      icon: BottomStack,
      from: "bottom",
      text: "Bottom to Top",
    },
    {
      icon: TopStack,
      from: "top",
      text: "Top to Bottom",
    },
  ];
  const getMinMax = (items, axis, dimensionKey) => ({
    min: Math.min(...items.map((i) => i.position[axis])),
    max: Math.max(
      ...items.map((i) => i.position[axis] + i.dimensions[dimensionKey])
    ),
  });
  const savePosition = (items) => {
    const itemsCopy = [...items];
    const groups = itemsCopy.filter((i) => i.type === "group");
    const modules = groups.map((e) => e.modules).flat();

    groups.forEach((g) => {
      const index = itemsCopy.findIndex((i) => i.id == g.id);
      itemsCopy.splice(index, 1);
    });

    const newItems = itemsCopy.concat(modules);

    alignItems({
      projectId: projectId,
      roomId: currentRoom.id,
      items: newItems.map(({ position, type, id }) => ({
        position,
        type,
        id,
      })),
    }).catch(({ error }) => {
      setIsNotificationVisible(true);
      setNotificationMessage({
        text: error,
        type: "danger",
      });
    });
  };
  const alignObjects = (items, direction) => {
    const oldPositions = {};
    const newPositions = {};

    if (
      ["left", "right", "top", "bottom", "h_center", "v_center"].includes(
        direction
      )
    ) {
      const isHorizontal = ["left", "right", "h_center"].includes(direction);
      const axis = isHorizontal ? "x" : "y";
      const dimensionKey = isHorizontal ? "width" : "height";

      const { min, max } = getMinMax(items, axis, dimensionKey);

      items.forEach((item) => {
        const oldPosition = { ...item.position };
        const newPosition = { ...oldPosition };

        let newValue = null;
        if (direction === "left" || direction === "bottom") newValue = min;
        else if (direction === "right" || direction === "top")
          newValue = max - item.dimensions[dimensionKey];
        else {
          const newCenter = min + (max - min) / 2;
          newValue = newCenter - item.dimensions[dimensionKey] / 2;
        }

        const moduleValues = newValue - item.position[axis];
        newPosition[axis] = newValue;
        item.position = newPosition;
        console.log(newPosition);
        oldPositions[getObjectKey(item)] = { ...oldPosition };
        newPositions[getObjectKey(item)] = { ...newPosition };

        if (item.type === "group")
          item.modules.forEach((m) => {
            const oldPosition = { ...m.position };
            const newPosition = { ...oldPosition };
            newPosition[axis] += moduleValues;
            m.position = newPosition;
            oldPositions[getObjectKey(m)] = { ...oldPosition };
            newPositions[getObjectKey(m)] = { ...newPosition };
          });
      });
    } else return;

    const groupIds = [
      ...new Set(items.map((i) => i.group_id).filter((i) => i)),
    ];

    groupIds.forEach((id) => {
      const group = selectionManager.findGroup(id);

      if (group.category === "BasicGroup") {
        const children = (group.modules || []).concat(group.walls || []);
        group.position = selectionManager.calculateGroupPosition(children);
        group.dimensions = selectionManager.calculateGroupDimensions(children);
      }
    });

    historyManager.add("move", oldPositions, newPositions);
    forceUpdate();
    savePosition(items);
  };
  const sortAndPositionItems = (items, axis, dimensionKey, ascending) => {
    items.sort((a, b) =>
      ascending
        ? a.position[axis] - b.position[axis]
        : b.position[axis] - a.position[axis]
    );

    let position = items[0].position[axis];

    for (let i = 0; i < items.length; i++) {
      if (i !== 0) {
        if (ascending) position += items[i - 1].dimensions[dimensionKey];
        else position -= items[i].dimensions[dimensionKey];
      }

      const moduleValues = position - items[i].position[axis];
      items[i].position[axis] = position;

      if (items[i].type === "group")
        items[i].modules.forEach((m) => (m.position[axis] += moduleValues));
    }
  };
  const stackObjects = (items, from) => {
    const oldPositions = {};
    const newPositions = {};
    items.forEach((item) => {
      const oldPosition = { ...item.position };
      oldPositions[getObjectKey(item)] = { ...oldPosition };
    });

    if (from === "left") sortAndPositionItems(items, "x", "width", true);
    else if (from === "right") sortAndPositionItems(items, "x", "width", false);
    else if (from === "top") sortAndPositionItems(items, "y", "height", false);
    else if (from === "bottom")
      sortAndPositionItems(items, "y", "height", true);
    else return;

    const groupIds = [
      ...new Set(items.map((i) => i.group_id).filter((i) => i)),
    ];

    groupIds.forEach((id) => {
      const group = selectionManager.findGroup(id);

      if (group.category === "BasicGroup") {
        const children = (group.modules || []).concat(group.walls || []);
        group.position = selectionManager.calculateGroupPosition(children);
        group.dimensions = selectionManager.calculateGroupDimensions(children);
      }
    });

    items.forEach((item) => {
      const newPosition = { ...item.position };
      newPositions[getObjectKey(item)] = { ...newPosition };
    });

    historyManager.add("move", oldPositions, newPositions);
    forceUpdate();
    savePosition(items);
  };
  return (
    <div>
      <div className="d-flex flex-column px-3 py-2">
        <div className="action-group-name fw-bold text-black pb-2">Align</div>

        <div
          className="d-grid gap-3"
          style={{
            gridTemplateColumns: "repeat(3, 1fr)", // Make sure 3 items fit fully
            boxSizing: "border-box",
          }}
        >
          {alignImages.map((e) => {
            const canAlign =
              selectionManager.canSelectionsAlign() ||
              (selectionManager.canSelectionsAlignInGroup() &&
                e.isApplicableForGroup);

            return (
              <div
                key={e.direction}
                className={`d-flex flex-column align-items-center justify-content-center p-2 border rounded align-objects ${
                  canAlign ? "" : "disabled"
                }`}
                style={{
                  boxSizing: "border-box",
                  textAlign: "center",
                  borderColor: canAlign ? "black" : "#ccc",
                  opacity: canAlign ? 1 : 0.5,
                }}
                onClick={() => {
                  if (canAlign) alignObjects(items, e.direction);
                }}
              >
                <e.icon className="icon-style" />
                <span className="pt-1 text-style">{e.text}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="d-flex flex-column px-3 py-2 pt-2">
        <div className="action-group-name fw-bold text-black pb-2 w-100">
          Arrange
        </div>
        <div className="d-flex flex-wrap justify-content-start gap-3">
          {stackImages.map((e) => {
            const canStack = selectionManager.canSelectionsAlign();

            return (
              <div
                key={e.from}
                className={`d-flex flex-column align-items-center justify-content-center p-2 border rounded align-objects ${
                  canStack ? "" : "disabled"
                }`}
                style={{
                  width: "calc(50% - 1rem)",
                  boxSizing: "border-box",
                  textAlign: "center",
                  borderColor: canStack ? "black" : "#ccc",
                  opacity: canStack ? 1 : 0.5,
                }}
                onClick={() => {
                  if (canStack) stackObjects(items, e.from);
                }}
              >
                <e.icon />
                <span className="pt-1">{e.text}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StackAndAlign;
